import React, { useMemo, useState } from "react";
import NotificationReportContext from "features/metadesk/Notification/NotificationReport/NotificationReport.context";
import useNotificationReportState from "features/metadesk/Notification/NotificationReport/NotificationReport.hooks";

import NotificationReportContent from "features/metadesk/Notification/NotificationReport/component/NotificationReportContent/NotificationReportContent";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";
import { alpha } from "@mui/material/styles";
import { useTheme } from "@mui/styles";
import { useOutletContext } from "react-router";
import { useFetchEntityConfig } from "features/metadesk/redux/hooks";
import { Tabs } from "@metacrm/metacrm-material-ui/dist/Tabs";
import SmartAlertReportContent from "./component/SmartAlertReportContent/SmartAlertReportContent";

const NotificationReportContainer = () => {
  const {
    notificationList,
    channelPerformance,
    setNotificationList,
    renderContents,
    searchText,
    page,
    dateRange,
    totalItems,
    handleChangePage,
    handleSearchChange,
    setDateRange,
    order,
    orderBy,
    handleRequestSort,
    loading,
    anchorEl,
    actionsList,
    handleCloseActions,
    isFeatureLocked,
  } = useNotificationReportState();
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const [entityName] = useOutletContext();
  const { entityConfig } = useFetchEntityConfig();
  const [selectedReport, setSelectedReport] = useState(0);

  const reportTabs = useMemo(() => {
    const tabs = [{ label: formatMessage({ id: "global.category.general" }) }];
    if (entityConfig?.smartNotifiationEnabled) {
      tabs.push({
        label: formatMessage({ id: "global.category.smartNotification" }),
      });
    }
    return tabs;
  }, [entityConfig]);

  const renderReportContents = () => {
    if (selectedReport === 1) {
      return <SmartAlertReportContent />;
    }
    return <NotificationReportContent />;
  };

  return (
    <NotificationReportContext.Provider
      value={{
        notificationList,
        channelPerformance,
        setNotificationList,
        renderContents,
        searchText,
        page,
        dateRange,
        totalItems,
        handleChangePage,
        handleSearchChange,
        setDateRange,
        order,
        orderBy,
        handleRequestSort,
        loading,
        anchorEl,
        actionsList,
        handleCloseActions,
        isFeatureLocked,
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        className="fade-up"
      >
        <Box className="title" sx={{ width: "100%", marginBottom: "12px" }}>
          {formatMessage({ id: "campaignPerformance.header.title" })}
        </Box>
      </Box>
      {reportTabs.length > 1 && (
        <Box mb={2}>
          <Tabs
            value={selectedReport}
            onChange={(e, newValue) => setSelectedReport(newValue)}
            tabs={reportTabs}
          />
        </Box>
      )}
      {renderReportContents()}
    </NotificationReportContext.Provider>
  );
};

export default NotificationReportContainer;
